import { create } from 'zustand';

import type { BulkResultItem } from '@nucleus-commerce/api-client/admin';

/** Products the create page could not put into a new schedule's pool, and why. */
export interface NotAdded {
  /** One refused row per product, as an add (or its whole-chunk refusal) answered it. */
  items: BulkResultItem[];
  /** Titles the create form knew, to name the rows. */
  titles: Record<string, string>;
}

interface NotAddedState {
  bySchedule: Record<string, NotAdded>;
  set: (scheduleId: string, notAdded: NotAdded) => void;
  clear: (scheduleId: string) => void;
}

/**
 * Hands the create page's leftovers to the detail page it navigates to. Too many ids for the URL
 * and nothing the server keeps, so it is client-local state; a reload drops it, which is fine,
 * since the products are simply not in the pool.
 */
export const useNotAddedStore = create<NotAddedState>()((set) => ({
  bySchedule: {},
  set: (scheduleId, notAdded) =>
    set((state) => ({ bySchedule: { ...state.bySchedule, [scheduleId]: notAdded } })),
  clear: (scheduleId) =>
    set((state) => {
      if (!(scheduleId in state.bySchedule)) return state;
      const { [scheduleId]: _gone, ...rest } = state.bySchedule;
      return { bySchedule: rest };
    }),
}));
